import { Layout } from "react-grid-layout";

/**
 * Adopt the server's set of containers without touching local geometry.
 *
 * Saving a layout invalidates the page query, so refetches keep arriving while
 * the user keeps editing. Geometry is owned locally (and synced to the backend
 * by the debounced save); the server only decides which containers exist.
 *
 * Returns the same reference when nothing structural changed.
 */
export function mergeStructuralLayout(local: Layout[], server: Layout[]): Layout[] {
  const localById = new Map(local.map((item) => [item.i, item]));

  const isSameStructure =
    local.length === server.length && server.every((item) => localById.has(item.i));

  if (isSameStructure) return local;

  return server.map((serverItem) => localById.get(serverItem.i) ?? serverItem);
}
